import { render, staticRenderFns } from "./userActiveView.vue?vue&type=template&id=a77d2aae"
import script from "@/scripts/userActive/userActiveView.js?vue&type=script&lang=js&external"
export * from "@/scripts/userActive/userActiveView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports